
// Main entry point for deep analysis services
import { analyzePageWithOpenAI } from './pageAnalysisService';
import { logAnalysisResult } from './loggingService';
import { getApiKey } from './apiKeyService';
import { analyzeContent } from '../deep-content-analysis';
import { testOpenAIConnection, runOpenAITest } from '../deep-content-analysis/runApiTest';

// Re-export all necessary functions for backward compatibility
export {
  analyzePageWithOpenAI,
  logAnalysisResult,
  analyzeContent,
  testOpenAIConnection,
  runOpenAITest,
  getApiKey
};

// Export a shorthand function for convenience
export const analyzeContentWithKey = (content: string) => {
  return analyzeContent(content);
};
